'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_table$package$() {
}
export { $c_Lpresto_table$package$ as $c_Lpresto_table$package$ };
$p = $c_Lpresto_table$package$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_table$package$;
/** @constructor */
function $h_Lpresto_table$package$() {
}
export { $h_Lpresto_table$package$ as $h_Lpresto_table$package$ };
$h_Lpresto_table$package$.prototype = $p;
var $d_Lpresto_table$package$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_table$package$, "presto.table$package$", ({
  XY: 1
}));
export { $d_Lpresto_table$package$ as $d_Lpresto_table$package$ };
var $n_Lpresto_table$package$;
function $m_Lpresto_table$package$() {
  if ((!$n_Lpresto_table$package$)) {
    $n_Lpresto_table$package$ = new $c_Lpresto_table$package$();
  }
  return $n_Lpresto_table$package$;
}
export { $m_Lpresto_table$package$ as $m_Lpresto_table$package$ };
//# sourceMappingURL=presto.table$package$.js.map
